import { useQuery } from 'data-fetching-client';
import { GET_FEATURES_BY_API_NAMES } from 'pricing-pages-api/features/queries';
export const useFeaturesByApiNames = ({
  productApiNames,
  i18nLangLocale = 'en'
}) => {
  const {
    data,
    error,
    loading
  } = useQuery(GET_FEATURES_BY_API_NAMES, {
    variables: {
      productApiNames,
      i18nLangLocale
    }
  });
  return {
    data: (data === null || data === void 0 ? void 0 : data.features) || [],
    error,
    loading
  };
};